import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { DocEntityBase } from "building-types/entities/docEntityBase";

export enum SlabType {
  CIP = "CIP",
  WOOD = "WOOD",
}
export interface SlabBase<T extends SlabType> extends DocEntityBase<"SLAB_COMPONENT"> {
  readonly id: PrimaryEntityId<"SLAB_COMPONENT">;
  readonly name: string;
  readonly slabType: T;
  readonly thickness: number;
}

//can have more properties for concrete, wood, and steel
export interface ConcreteSlab extends SlabBase<SlabType.CIP> {}

export interface WoodSlab extends SlabBase<SlabType.WOOD> {}

//export interface SteelSlab extends SlabBase<SlabType.STEEL> {}

export type SlabComponentEntity = ConcreteSlab | WoodSlab; // | SteelSlab;

export type SlabComponentId = SlabComponentEntity["id"];

export type SlabComponentEntityTable = {
  [id: SlabComponentId]: SlabComponentEntity;
};
